module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "dialogClass": "report-modal",
      "id": "report-modal",
      "open": _vm.open
    },
    on: {
      "close": _vm.close,
      "click": _vm.close
    }
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Reporting a post")]), _vm._v(" "), _c('p', [_vm._v("Please choose a reason for reporting this post")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason, index) {
    return _c('div', {
      key: ("reason-" + index),
      staticClass: "radio"
    }, [_c('mu-radio', {
      attrs: {
        "name": "group",
        "label": reason.reason,
        "nativeValue": ("" + (reason.id))
      },
      model: {
        value: (_vm.chosen_reason),
        callback: function($$v) {
          _vm.chosen_reason = $$v
        },
        expression: "chosen_reason"
      }
    })], 1)
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action-btn",
    attrs: {
      "slot": "actions",
      "label": "Cancel"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action-btn",
    attrs: {
      "slot": "actions",
      "label": "Okay",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    },
    slot: "actions"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ec18ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/Reporting.vue
// module id = 3120
// module chunks = 1